import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useFetch from "../hooks/useFetch";
import DivisionsListingCard from "../components/DivisionsListingCard";

const Divisions: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams<{ event_id: string }>();
  const event_id = params?.event_id || localStorage.getItem("eventId");
  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;

 
  //const [dropdownHeading, setDropdownHeading] = (currentRole==3 || currentRole==6) ? useState<string>("My Team") : useState<string>("Active");
  const [dropdownHeading, setDropdownHeading] = (currentRole==3 || currentRole==6) ? useState<string>("View All") : useState<string>("Active");
  //const [apiParams, setApiParams] = (currentRole==3 || currentRole==6) ? useState<string>('&status=myteam') : useState<string>('&status=active');
  const [apiParams, setApiParams] = (currentRole==3 || currentRole==6) ? useState<string>('&status=View All') : useState<string>('&status=active');
  const [dropdownState, setDropdownState] = useState(false);
  function setParamAndFetch(status:string){
    if(status == 'active') setDropdownHeading('Active')
    else if(status == 'approved') setDropdownHeading('Approved')
    else if(status == 'ready_to_announce') setDropdownHeading('Ready To Announce')
    else if(status == 'published') setDropdownHeading('Published/Past')
    else if(status == 'myteam') setDropdownHeading('My Team')
    else setDropdownHeading('View All');
    setApiParams(status ? '&status='+status : '');
  }

  const { data, fetchData, errorContent, isLoading, hasFetched } = useFetch({
    url: `${
      import.meta.env.VITE_API_URL
    }/divisions_performance_groups/by-event-id?event_id=${event_id}${apiParams}`,
    method: "GET",
  });
  
  useEffect(() => {
    fetchData();
  }, [apiParams]);

  if (errorContent) return errorContent;

  if (!hasFetched) {
    return null; // Prevent rendering until fetch is complete
  }

  return (
    <>
      <section className="headersection2">
        <div className="w-layout-blockcontainer container-main-content w-container">
          <div className="div-header-title-section">
            <div
              className="link-block w-inline-block cursor-pointer"
              onClick={() => {
                /*if (currentRole == "1" || currentRole == "8" || currentRole == "7") {
                  navigate(`/admin/events/${data?.competition?.id}`);
                } else {
                  navigate(`/events/${data?.competition?.id}`);
                }*/
              navigate(`/events/${data?.competition?.id}`);
              }}
            >
              <img
                src="/images/back-icon.png"
                loading="lazy"
                alt=""
                className="image-2"
              />
              <h1 className="back-text-link">{data?.competition?.title}</h1>
            </div>
            <h1 className="judgingapp-heading2">{data?.event?.location}</h1>
            <p className="paragraph-2">{data?.event?.event_date}</p>
          </div>
        </div>
      </section>
      <section style={{backgroundColor: 'white'}}>
        
        {
          (data?.myteamdivisions && data.myteamdivisions?.length > 0) ? (
            <DivisionsListingCard
            type='My Team'
            divisions={data?.myteamdivisions}
            settings_color_code={data?.settings_color_code}
            setParamAndFetch={setParamAndFetch}
            dropdownState={false}
            setDropdownState={setDropdownState}
            dropdownHeading="My Team"
            isLoading={false}
            excel_status={data?.downloadExcel?.status}
            excel_file={data?.downloadExcel?.filename}
            excel_title={data?.event?.location}
            />
          ):('')
        }
        <DivisionsListingCard
        type='All'
        divisions={data?.divisions}
        settings_color_code={data?.settings_color_code}
        setParamAndFetch={setParamAndFetch}
        dropdownState={dropdownState}
        setDropdownState={setDropdownState}
        dropdownHeading={dropdownHeading}
        isLoading={isLoading}
        excel_status={(currentRole == 1) ? data?.downloadExcel?.status : false}
        excel_file={data?.downloadExcel?.filename}
        excel_title={data?.event?.location}
        />
      </section>
    </>
  );
};

export default Divisions;
